import React, { useEffect, useReducer, useState } from 'react';
import TextInput from '../../components/Common/TextInput';
import CallOut from '../../components/Common/CallOut';
import Notification from '../../components/Common/Notification';
import { useSchool } from '../../DataStore/SchoolContext';
import ajaxSchool from '../../util/remote/ajaxSchool';
import AlertNotification from '../../components/Common/AlertNotification';
import { useTheme } from '../../DataStore/ThemeContext';

const reducer = (state, action)=>{
        if(action.type === "RESET"){
            return {...initialState}
        }
        return { ...state, [action.type]: action.value };
}

const initialState = {
    vote: '',
    amount: '',
    validity: '',
    loading: false,
}


const NewFeesDiscount = ({studentIds}) => {
    const [info, setInfo] = useState(null);
    const [state, dispatch] = useReducer(reducer, initialState);
    const {getFeesVotes, feesVoteListing} = useSchool();
    const {setSystemFunction} = useTheme();

    useEffect(()=>{
        setSystemFunction(() => async () => {
            await handleConfirm();
        });
    }, [state]);

    useEffect(()=>{
        getFeesVotes();
    }, [])
    

    useEffect(()=>{
        if(info){
            setTimeout(() => {
                setInfo(null);
            }, 5000);
        }
    }, [info]);

    const handleConfirm = async () =>{
       
        if(studentIds.length === 0){
            setInfo(<Notification type='danger' message="No student selection found. Please make selection then try again"/>);
            return;
        }
        if(!state.vote.value || !state.validity.value){
            setInfo(<Notification type='danger' message="Select both Vote and Validity, then try again"/>);
            return;
        }

        const server_response = await ajaxSchool.createDiscount({
            "student_ids":studentIds,
            "vote_id":state.vote.value,
            "amount":state.amount,
            "recurring":state.validity.value
        });
        if(server_response.status==="OK"){
            //reset amount
            dispatch({type:'amount', value: ''})
            setInfo(<Notification type='success' message={server_response.message} closable={false}/>);
        }else{
            setInfo(<Notification type='danger' message={server_response.message} closable={false}/>)
        }


    }


    const RenderVotes = () => {

        const options=[];
            if(Array.isArray(feesVoteListing))
            {
                feesVoteListing.map((item, key)=>
                    options.push({label:item.vote_name, value:item.id})
                )
            }
    
            return(
                <TextInput
                    type="select"
                    label="Select Fees Vote"
                    placeholder="Select vote"
                    leftIcon="fa fa-tag"
                    options={options}
                    onChange={item => dispatch({type: 'vote', value: item})}
                    leftComponent={<i className="fa fa-tag link" onClick={()=>getFeesVotes(true)}></i>}
                    loading={!feesVoteListing}
                    required
                    wrap
                    value={state.vote}
            />
    
            )
      }
    



    return (
        <>

            <CallOut 
                title="Fees Discount"
                description="Apply discounts on specific fees votes for individual students. These discounts can be one-time or recurring."
             />
             <div className='mt-4'>
                <Notification type='warning' message={`You are about to apply a fees discount to ${studentIds.length} student${studentIds.length > 1 ? 's' : ''}.`}/>
            </div>
            <div className='mt-4'>{info}</div>
            <form className="form-horizontal" method="post" onSubmit={handleConfirm}>

                {RenderVotes()}

                <TextInput
                    type="number"
                    label="Discounted Amount"
                    placeholder="Enter Discounted Amount"
                    leftIcon="fa fa-money-bill"
                    onChange={(e)=>dispatch({type:'amount', value: e.target.value})}
                    required
                    wrap
                    name="Amount"
                    value={state.amount}
                    />



                <TextInput
                    type="select"
                    label="Discount Validity"
                    placeholder="Select Discount Validity"
                    leftIcon="fa fa-calendar-alt"
                    onChange={(item)=>dispatch({type:'validity', value: item})}
                    options={[{"label":"One time", "value":"0"}, {"label":"Recurring", "value":"1"}]} 
                    required
                    wrap
                    value={state.validity}
                    />


            </form> 

        </>
    );
};

export default NewFeesDiscount;